import { useEffect, useState } from "react";
import { getProductVariants } from "../../api/productVariants";

export function useExchangeCatalog(order) {
  const [catalog, setCatalog] = useState({});
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    if (!order?.allow_exchanges || !order?.shipInsureID) {
      setCatalog({});
      setStatus("idle");
      return undefined;
    }

    let cancelled = false;
    setStatus("loading");
    getProductVariants(order.shipInsureID)
      .then((response) => {
        if (cancelled) return;
        const byProduct = {};
        (response.data || []).forEach((product) => {
          byProduct[String(product.product_id)] = product.variants || [];
        });
        setCatalog(byProduct);
        setStatus("ready");
      })
      .catch(() => {
        if (!cancelled) {
          setCatalog({});
          setStatus("error");
        }
      });

    return () => {
      cancelled = true;
    };
  }, [order?.allow_exchanges, order?.shipInsureID]);

  return { catalog, status };
}
